import CustomFieldGroup_Entity from "./customFieldGroup";

export default class CustomFieldGroup extends CustomFieldGroup_Entity {
  static fromList(customFieldGroupsJSON: unknown): CustomFieldGroup[] {
    const customFieldGroups: CustomFieldGroup[] = [];
    if (customFieldGroupsJSON)
      Array.isArray(customFieldGroupsJSON) &&
        customFieldGroupsJSON.forEach((customFieldGroupJSON) => {
          customFieldGroups.push(new CustomFieldGroup(customFieldGroupJSON));
        });
    return customFieldGroups;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
